class PwnageToast {
  constructor(images) {
    this.toast = document.createElement("div")
    this.toast.classList.add("toast")
    this.toast.classList.add("toast--init")
    this.toast.classList.add("content-box--small")

    let imagesHTML = ""
    for (let imageUrl of images) {
      imagesHTML += `<div class="image"><img src=${imageUrl}></div>`
    }

    this.toast.innerHTML = `
            <div class="toast-status">
                <i class="fas fa-sync-alt"></i>
            </div>
            <pwn-flex vcenter no-wrap-important class="relative">
                ${imagesHTML}
                <div class="small-padding-left hide error">
                    <h5 class="title error__title no-margin-bottom"></h5>
                    <p class="small error__details"></p>
                </div>
            </pwn-flex>
        `

    document.body.appendChild(this.toast)
    window.setTimeout(() => this.setState(""), 10)
  }

  setState(state = "toast", data) {
    if (state == "toast--done") {
      this.toast.querySelector("i").classList.remove("fa-sync-alt")
      this.toast.querySelector("i").classList.add("fa-check")
    }
    if (state == "toast--fly") {
      window.setTimeout(
        () => this.toast.parentNode.removeChild(this.toast),
        1200
      )
    }
    if (state == "toast--error") {
      this.toast.querySelector(".error").classList.remove("hide")
      if (data.status == 404) {
        this.toast.querySelector(".error__title").innerHTML = "Product Error"
        this.toast.querySelector(".error__details").innerHTML =
          "Product doesn't exist"
      } else if (data.status == 422) {
        this.toast.querySelector(".error__title").innerHTML = "Inventory Empty"
        this.toast.querySelector(".error__details").innerHTML = data.description
      }
      this.toast.querySelector("i").classList.remove("fa-sync-alt")
      this.toast.querySelector("i").classList.add("fa-exclamation-circle")
      this.toast.querySelector("i").style.color = "#ee4519"
    }
    this.toast.classList.remove("toast--init")
    this.toast.classList.remove("toast--fly")

    if (state) this.toast.classList.add(state)
  }
}
